// Путь: D:\QR\QR-WEB\dashboard\src\components\Auth\ForgotPassword.js
// Версия: 1.0.0
// Дата: 02.12.2025

import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import './Auth.css';

const API_URL = process.env.REACT_APP_API_URL || 'https://qr-money.onrender.com';

const ForgotPassword = () => {
  const [step, setStep] = useState(1); // 1=email, 2=code, 3=newPassword
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Шаг 1: Отправка кода на email
  const handleSendCode = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await axios.post(`${API_URL}/api/auth/forgot-password`, { email });
      setSuccess('Код отправлен на ваш email');
      setStep(2);
    } catch (err) {
      setError(err.response?.data?.message || 'Ошибка отправки');
    } finally {
      setLoading(false);
    }
  };

  // Шаг 2: Ввод кода и нового пароля
  const handleResetPassword = async (e) => {
    e.preventDefault();
    setError('');

    if (newPassword !== confirmPassword) {
      setError('Пароли не совпадают');
      return;
    }

    if (newPassword.length < 6) {
      setError('Пароль минимум 6 символов');
      return;
    }

    setLoading(true);

    try {
      await axios.post(`${API_URL}/api/auth/reset-password`, {
        email,
        code,
        newPassword
      });
      setSuccess('Пароль успешно изменён!');
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setError(err.response?.data?.message || 'Неверный код');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-info">
        <div className="auth-info-content">
          <div className="brand">
            <span className="brand-icon">🔐</span>
            <h1 className="brand-name">DARY</h1>
            <p className="brand-tagline">Восстановление пароля</p>
          </div>
          
          <div className="features">
            <h2>Забыли пароль?</h2>
            <p className="features-desc">
              Не переживайте! Мы отправим код для сброса пароля на ваш email.
            </p>
            
            <ul className="features-list">
              <li>
                <span className="feature-icon">1️⃣</span>
                <div>
                  <strong>Введите email</strong>
                  <span>Укажите email вашего аккаунта</span>
                </div>
              </li>
              <li>
                <span className="feature-icon">2️⃣</span>
                <div>
                  <strong>Получите код</strong>
                  <span>Проверьте почту</span>
                </div>
              </li>
              <li>
                <span className="feature-icon">3️⃣</span>
                <div>
                  <strong>Создайте новый пароль</strong>
                  <span>Минимум 6 символов</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="auth-form-section">
        <div className="auth-card">
          <div className="auth-card-header">
            <h2>{step === 1 ? 'Сброс пароля' : step === 2 ? 'Введите код' : 'Новый пароль'}</h2>
            <p>{step === 1 ? 'Введите email для получения кода' : step === 2 ? 'Код отправлен на ' + email : 'Придумайте новый пароль'}</p>
          </div>

          {error && <div className="auth-error">{error}</div>}
          {success && <div className="auth-success">{success}</div>}

          {step === 1 && (
            <form onSubmit={handleSendCode} className="auth-form">
              <div className="form-group">
                <label>Email</label>
                <div className="input-wrapper">
                  <span className="input-icon">📧</span>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="your@email.com"
                    required
                  />
                </div>
              </div>

              <button type="submit" disabled={loading} className="btn-submit">
                {loading ? '⏳ Отправка...' : '📧 Отправить код'}
              </button>
            </form>
          )}

          {step === 2 && (
            <form onSubmit={handleResetPassword} className="auth-form">
              <div className="form-group">
                <label>Код из письма</label>
                <div className="input-wrapper">
                  <span className="input-icon">🔢</span>
                  <input
                    type="text"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    placeholder="123456"
                    maxLength={6}
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label>Новый пароль</label>
                <div className="input-wrapper">
                  <span className="input-icon">🔑</span>
                  <input
                    type="password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    placeholder="Минимум 6 символов"
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label>Подтвердите пароль</label>
                <div className="input-wrapper">
                  <span className="input-icon">🔑</span>
                  <input
                    type="password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    placeholder="Повторите пароль"
                    required
                  />
                </div>
              </div>

              <button type="submit" disabled={loading} className="btn-submit">
                {loading ? '⏳ Сохранение...' : '✓ Сменить пароль'}
              </button>
            </form>
          )}

          <div className="auth-divider">
            <span>или</span>
          </div>

          <Link to="/login" className="btn-register">
            ← Вернуться ко входу
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;